export function isIE() {
  const ua = window.navigator.userAgent;
  return /MSIE|Trident/.test(ua);
}

export function isOpera() {
  return (!!window.opr && !!window.opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
}
